import { render, staticRenderFns } from "./MaterialMenu.vue?vue&type=template&id=5bdee547&scoped=true&"
import script from "./MaterialMenu.vue?vue&type=script&lang=js&"
export * from "./MaterialMenu.vue?vue&type=script&lang=js&"
import style0 from "./MaterialMenu.vue?vue&type=style&index=0&id=5bdee547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdee547",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
